import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { OpsappService } from '../../services/opsapp.service';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-gure-dashboard',
  templateUrl: './gure-dashboard.component.html',
  styleUrls: ['./gure-dashboard.component.css']
})
export class GureDashboardComponent {

  grouping: any[] = [{id: "1", name: "Plates"}, {id: "0", name: "Orders"}, {id: "2", name: "For Me"}, {id: "3", name: "Upcoming"}];
  selectedGroup: any;
  oldSelectedGroup: any;
  pendingOrderGroups: any = [];
  loading: boolean;
  pendingPlateGroups: any = [];
  plateTotal: any;
  orderTotal: any;


  //This is duplicated from the worklist page.  consider abstracting
  currentLimsToken: any;
  limsLoginModal: boolean;
  username: string;
  password: string;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private cookieService: CookieService){
    
  }

  

  ngOnInit(){
    this.selectedGroup = {id: "1", name: "Plates"};
    this.oldSelectedGroup = {id: "0", name: "None"};
    this.getLimsTokenCookie();
    this.getUserToken();
  }
  
  loadData(){
    if (this.oldSelectedGroup.id != this.selectedGroup.id)
    {
      this.oldSelectedGroup = this.selectedGroup;
      this.pendingOrderGroups = [];
      this.pendingPlateGroups = [];
      if (this.selectedGroup.id == 1)
      {
        this.loadPendingPlates();
      }
      else
      {
        this.loadPendingOrders();
      }
    }
  }

  loadPendingOrders(){
    this.loading = true;
    var pendingOrdersOptions = {
      Token: this.currentLimsToken,
      Grouping: this.selectedGroup.id
    };

    this.opsappService.getPendingOrders(pendingOrdersOptions).then(data => {
      this.pendingOrderGroups = data;
      console.log(data);
      this.orderTotal = this.calculateOrderTotal();
      this.loading = false;
    });

  }

  loadPendingPlates(){
    this.loading = true;
    this.opsappService.getPendingPlates(this.currentLimsToken).then(data => {
      this.pendingPlateGroups = data;
      console.log(data);
      this.plateTotal = this.calculatePlateTotal();
      this.loading = false;
    });
  }

  calculatePlateTotal(){
    var total = 0;
    this.pendingPlateGroups.forEach((group: any) => {
      total += group.plates.length;
    });
    return total;
  }

  calculateOrderTotal(){
    var total = 0;
    this.pendingOrderGroups.forEach((group: any) => {
      total += group.orders.length;
    });
    return total;
  }

  clearUserToken(){
    this.opsappService.limsToken.next(null);
    this.currentLimsToken = null;
  }

  addUserToken(token: any){
    this.opsappService.limsToken.next(token);
    this.currentLimsToken = token;
  }

  getUserToken(){
    this.opsappService.limsToken.pipe(first()).subscribe(token => {
      if (token == null)
        this.limsLoginModal = true;
      else
      {
        this.currentLimsToken = token;
        this.loadData();
      }
    });
  }

  loginModalSubmit(){
    var basicAuthOptions = {
      UserName: this.username,
      Password: this.password
    }

    this.opsappService.getLimsToken(basicAuthOptions).then(data => 
      {
        if (data == "error")
          this.messageService.add({severity:'error', summary: "Could not log in to Lims."});
        else{
          this.addUserToken(data);
          this.setLimsTokenCookie(data);
          this.loadData();
          this.limsLoginModal = false;
        }
      })
  }

  groupingChange(){
    this.getUserToken();
  }

  retestCount(objType: string, objArray: any){
    if (objType == "order")
      return objArray.filter((x: any) => x.order.isRetest).length;
    else if (objType == "plate")
      return objArray.filter((x: any) => x.isRetest).length;
  }

  nonRetestCount(objType: string, objArray: any){
    if (objType == "order")
      return objArray.filter((x: any) => !x.order.isRetest).length;
    else if (objType == "plate")
      return objArray.filter((x: any) => !x.isRetest).length;
  }

  getLimsTokenCookie(){
    var token = this.cookieService.get("limsToken");
    if (token != undefined)
      this.addUserToken(token)
  }

  setLimsTokenCookie(token: string){
    this.cookieService.put("limsToken", token);
  }
}
